<template>
  <div class="wrap">
    <div class="guest">
      <div class="guestTitle">重磅嘉宾</div>
      <div class="guestEn">IMPORTANT GUESTS</div>
      <div class="guestStatement"></div>
      <a-carousel arrows :dots="false" autoplay :autoplaySpeed="3000">
        <template #prevArrow>
          <div
            class="custom-slick-arrow custom-slick-arrow-left"
            style="left: 0; top: 192px; z-index: 1"
          >
            <img
              class="arrow"
              src="https://p1.ssl.qhimg.com/t110b9a9301bf0e594b9ca06ee7.png"
              alt=""
            />
          </div>
        </template>
        <template #nextArrow>
          <div class="custom-slick-arrow custom-slick-arrow-right" style="top: 192px; left: 97%">
            <img
              class="arrow"
              src="https://p3.ssl.qhimg.com/t110b9a9301ba3128d7da220256.png"
              alt=""
            />
          </div>
        </template>
        <div v-for="(item, index) in arr" :key="index" class="guestBox">
          <div class="guestBoxInfo">
            <div v-for="(child, index) in item" :key="index" class="guestBoxInfoItem">
              <img :src="child.avatar" alt="" class="guestBoxInfoItemImg" />
              <div class="guestBoxInfoItemName">{{ child.name }}</div>
              <div class="guestBoxInfoItemTitle van-multi-ellipsis--l3">
                <a-tooltip>
                  <template #title>
                    <div class="tooltip-content">{{ child.title.join(',') }}</div>
                  </template>
                  {{ child.title.join(',') }}
                </a-tooltip>
              </div>
            </div>
          </div>
        </div>
      </a-carousel>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getKeyGuest } from '@/api/2024/index'
// const arr = ref([
//   [
//     {
//       photo: 'https://p1.ssl.qhimg.com/t110b9a93015ce06f618f2fd9ee.png',
//       name: '邬贺铨',
//       title: 'ISC名誉主席,中国工程院院士'
//     },
//     {
//       photo: 'https://p1.ssl.qhimg.com/t110b9a9301f0e4205421cc4758.png',
//       name: '王秀军',
//       title: 'ISC名誉主席,中国网络空间安全协会理事长'
//     },
//     {
//       photo: 'https://p5.ssl.qhimg.com/t110b9a93013d74e2c336ea90d9.png',
//       name: '周鸿祎',
//       title: 'ISC大会主席，360集团董事长兼CEO'
//     }
//   ],
//   [
//     {
//       photo: 'https://p1.ssl.qhimg.com/t110b9a93015ce06f618f2fd9ee.png',
//       name: 'wu',
//       title: 'ISC名誉主席,中国工程院院士'
//     },
//     {
//       photo: 'https://p1.ssl.qhimg.com/t110b9a9301f0e4205421cc4758.png',
//       name: '王秀军',
//       title: 'ISC名誉主席,中国网络空间安全协会理事长'
//     },
//     {
//       photo: 'https://p5.ssl.qhimg.com/t110b9a93013d74e2c336ea90d9.png',
//       name: '周鸿祎',
//       title: 'ISC大会主席，360集团董事长兼CEO'
//     }
//   ]
// ])

const arr = ref([])

onBeforeMount(async () => {
  await fetch()
})

const fetch = () => {
  getKeyGuest('ISC 荣誉主席,重磅嘉宾').then((res) => {
    let guests = res.data.data
    arr.value = chunkArray(guests, 3)
  })
}

const chunkArray = (array, chunkSize) => {
  const result = []
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize))
  }
  return result
}
</script>

<style lang="scss" scoped>
.wrap {
  opacity: 1;
  background-color: #f3f3f3;
  padding: 87px 0 63px;
  // background-color: pink;
}

.guest {
  width: 90%;
  min-width: 1230px;
  margin: 0 auto;
  &Title {
    font-family: Source Han Sans;
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: 0px;
    color: #242933;
  }
  &En {
    margin-top: 16px;
    margin-bottom: 48px;
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #8a9099;
    display: inline-block;
  }
  &Statement {
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    margin-bottom: 69px;
  }
  &Box {
    // background-color: pink;
    &Info {
      display: flex;
      justify-content: space-between;
      &Item {
        width: 320px;
        &Img {
          width: 320px;
          height: 320px;
          border-radius: 50%;
          margin-bottom: 45px;
        }
        &Name {
          font-family: Source Han Sans;
          font-size: 24px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: 0px;
          font-variation-settings: 'opsz' auto;
          /* Gray 中性/gray-9 */
          color: #242933;
          margin-bottom: 20px;
        }
        &Title {
          padding: 0 20px;
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: normal;
          line-height: 16px;
          text-align: center;
          letter-spacing: 0px;
          font-variation-settings: 'opsz' auto;
          color: rgba(61, 61, 61, 0.698);
        }
      }
    }
  }
}
.arrow {
  width: 48px;
}
:deep(.slick-slide) {
  text-align: center;
  padding: 0 116px 120px;
  //   background-color: pink;
}

.ant-carousel :deep(.slick-dots li button) {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #dfe1e6;
}
:deep(.slick-dots li.slick-active button) {
  background-color: #525966 !important;
}
</style>
